export const metisZaps = [
  {
    // Netswap
    zapAddress: '0xF439B695bB28c9E9865170C1b3e98F5EB4cE9b48',
    ammRouter: '0x1E876cCe41B7b844FDe09E38Fa1cf00f213bFf56',
    ammFactory: '0x70f51d68D16e8f9e418441280342BD43AC9Dff9f',
    ammPairInitHash: '0x966d65068a6a30f10fd1fa814258637a34e059081d79daa94f3e2b6cec48e810',
  },
  {
    // Tethys
    zapAddress: '0x8c2d54BA94f4638f1bb91f623F378B66d6023324',
    ammRouter: '0x81b9FA50D5f5155Ee17817C21702C3AE4780AD09',
    ammFactory: '0x2CdFB20205701FF01689461610C9F321D1d00F80',
    ammPairInitHash: '0xef3f1aabf6b944a53c06890783ddef260a21995d1eaea6d52f980cfe082a877d',
  },
];
